// extracted by mini-css-extract-plugin
export var container = "_c0-1";
export var cornerButtonContainer = "_c0-6";
export var disabled = "_c0-2";
export var dragActive = "_c0-3";
export var fileContainer = "_c0-5";
export var hiddenInput = "_c0-4";
export var widthContainer = "_c0-0";